module.exports = __webpack_public_path__ + "img/dashboard-color.2e118037.svg";